// InventoryLayout.jsx

import InventoryMenu from './InventoryMenu';
import SidebarLayout from '../shared/SidebarLayout';

function InventoryLayout() {
  return (
    <SidebarLayout MenuComponent={InventoryMenu} />
  );
}

export default InventoryLayout;
